'use strict';

angular.module('app')

.directive('compPanel', function ()
{
    var link = function ($scope, element, attributes, component)
    {
        // show options dropdown if we have height or footnote
        $scope.enableOptions = component.options.height || component.options.footnote;

        // footnote option
        $scope.enableFootnoteOption = component.options.footnote;
        $scope.data.footnote = $scope.data.footnote || '';

        // height option
        $scope.enableHeightOption = component.options.height;
        $scope.data.height = $scope.data.height || 0;
        $scope.data.showHeightOption = $scope.data.showHeightOption || false;

        // Use the editors available background colors for this component as well
        $scope.backgroundColors = component.editor.options.backgroundColors;

        $scope.updateHeight = function ()
        {
            if (!$scope.enableHeightOption || !$scope.data.showHeightOption) {
                delete $scope.model.style.minHeight;
                return;
            }

            $scope.model.style.minHeight = $scope.model.data.height + 'px';
        };

        // Backwards compatibility
        if ($scope.model.bgrColour) {
            $scope.model.style.backgroundColor = $scope.model.bgrColour;
            delete $scope.model.bgrColour;
        }

        // Backwards compatibilty
        if ($scope.model.style.background) {
            $scope.model.style.backgroundColor = $scope.model.style.background;
            delete $scope.model.style.background;
        }

        // Default the background
        if (!$scope.model.style.backgroundColor) {
            $scope.model.style.backgroundColor = component.options.defaultBackground;
        }

        // Auto-focus the nested component list when focusing this comonent
        component.setFocusRequestHandler(function ()
        {
            $scope.$broadcast('component:request-focus', $scope.model.nested);
        });
    };

    return {
        restrict: 'A',
        replace: true,
        require: '^component',
        templateUrl: 'modules/programme/editor-components/compPanel.html',
        link: link
    };
});
